import { useState, useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import BusinessNavbar from 'components/Navbars/BusinessNavbar'
import ItemTabs from 'components/ItemTabs'
import EditProfessionalPersonalInfo from './PersonalInfo'
import EditProfessionalAgenda from './Agenda'
import EditProfessionalServices from './Services'
import EditProfessionalSecurity from './Security'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, TabStickyContainer, Title } from './styles'

export default function EditProfessional (props) {
  const location = useLocation ()
  const { id: professional_id } = useParams ()
  const configOption = location.state?.configOption ?? null
  const [loading, setLoading] = useState (true)
  const [selectedTab, setSelectedTab] = useState (configOption ?? 'personal')
  const [professional, setProfessional] = useState (null)
  const [professionalCategories, setProfessionalCategories] = useState ([])
  const [professionalWorkingDays, setProfessionalWorkingDays] = useState ([])
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleWorkingDaysUpdated = updatedWorkingDays => {
    setProfessionalWorkingDays (updatedWorkingDays)
    
    const acceptsCutilei = updatedWorkingDays.some (day => day.accepts_cutilei)

    setProfessional (prev => ({ ...prev, accepts_cutilei: acceptsCutilei }))
  }

  const TAB_LIST = [
    {
      label: 'Dados pessoais',
      value: 'personal',
      visible: true,
      component: <EditProfessionalPersonalInfo
        professional={professional}
        onPictureChange={newPicture => {
          setProfessional (prev => ({ ...prev, profile_picture: newPicture }))
        }}
      />
    },
    {
      label: 'Agenda',
      value: 'agenda',
      visible: true,
      component: <EditProfessionalAgenda
        professional={professional}
        professionalWorkingDays={professionalWorkingDays}
        professionalCategories={professionalCategories}
        onWorkingDaysUpdated={handleWorkingDaysUpdated}
        {...props}
      />
    },
    {
      label: 'Serviços',
      value: 'services',
      visible: true,
      component: <EditProfessionalServices
        professional={professional}
        professionalCategories={professionalCategories}
        professionalWorkingDays={professionalWorkingDays}
        onCategoriesUpdated={setProfessionalCategories}
        onWorkingDaysUpdated={setProfessionalWorkingDays}
        {...props}
      />
    },
    {
      label: 'Segurança',
      value: 'security',
      visible: AuthService.hasPermission ('business_config.professionals', 'edit'),
      component: <EditProfessionalSecurity
        professional={professional}
        onValidationPermissionUpdated={setProfessional}
      />
    }
  ]

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      const { data: professional } = await cutileiApi.get (
        `/businesses/${businessId}/professionals/${professional_id}`, requestConfig
      )
      const { data: professionalCategories } = await cutileiApi.get (
        `/businesses/${businessId}/professionals/${professional.id}/service_categories?status=active`,
        requestConfig
      )
      const { data: professionalWorkingDays } = await cutileiApi.get (
        `/businesses/${businessId}/professionals/${professional?.id}/working_days`
      )

      setProfessional (professional)
      setProfessionalCategories (professionalCategories)
      setProfessionalWorkingDays (professionalWorkingDays)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container style={{paddingLeft: 50}}>
      <BusinessNavbar/>
      <Title>
        Editar profissional{professional && ` - ${professional.name}`}
      </Title>
      {loading ? <Loading style={{marginTop: 20}}/> : (
        <>
          <TabStickyContainer>
            <ItemTabs
              tabs={TAB_LIST.filter (tab => tab.visible)}
              selectedTab={selectedTab}
              onTabChange={setSelectedTab}
            />
          </TabStickyContainer>
          {TAB_LIST.find (tab => tab.value === selectedTab).component}
        </>
      )}
    </Container>
  )
}
